import React, { type ComponentType } from "react";
import { FormattedMessage } from "react-intl";
import type { IIntegrationFormImplProps } from "src/integrations/forms/IIntegrationFormImplProps";
import { INTEGRATION_SHOPIFY_IS_RESTRICTED } from "src/integrations/forms/shopify/IIntegrationFormDataShopify";
import { Tooltip } from "src/shared/formatters/Tooltip";
import { CheckboxInput } from "src/shared/forms/inputs/CheckboxInputOld";
import { InfoCircle } from "src/shared/icons/IconCircle";

export const ShopifyIsRestrictedInput: ComponentType<
  IIntegrationFormImplProps
> = () => {
  return (
    <CheckboxInput
      inputID={INTEGRATION_SHOPIFY_IS_RESTRICTED}
      label={<FormattedMessage id="integrations.shopify.isRestricted" />}
      disabled
      tooltip={
        <Tooltip
          tag="span"
          isOpen
          tooltipProps={{ placement: "right" }}
          tooltipRender={
            <FormattedMessage id="integrations.shopify.isRestricted.tooltip" />
          }
        >
          <InfoCircle />
        </Tooltip>
      }
    />
  );
};
